import Button from '@blocks/Button'
import Flex from '@blocks/Flex'
import Form from '@blocks/Form'
import Grid from '@blocks/Grid'
import Input from '@blocks/Input'
import TextArea from '@blocks/Input/TextArea'
import useSupportController from '@general/api/useSupportController'
import { notify, route } from '@helpers'
import useAuth from '@hooks/useAuth'
import useTitle from '@hooks/useTitle'
import { Box, Container } from '@styles/helpers'
import { tablet } from '@styles/mixins'
import React from 'react'
import styled, { css } from 'styled-components'

export default function SupportPage() {
    const controller = useSupportController() 
    const { user } = useAuth()
    
    useTitle("Support")

    const onSuccess: GetProps<typeof Form>["handleSuccess"] = (data, form) => {
        notify("Thanks! We received your email.")
        form?.reset()
    }

    return (
        <SupportWrapper>
            <SupportBox>
                <Grid>
                    <Grid gap="15px">
                        <h1 className="h2">Support</h1>
                        <p>Feel free to address any issue to our support</p>
                    </Grid>
                    <Grid gap="20px">
                        <Form handleSubmit={controller.store} handleSuccess={onSuccess}>
                            <Grid gap="15px" columns="2">
                                <Input id="name" name="name" label="Name" placeholder="John Doe" defaultValue={user ? `${user.first_name} ${user.last_name}` : undefined} required />
                                <Input id="email" name="email" label="Email" placeholder="email@example.com" defaultValue={user?.email || undefined} required />
                            </Grid>
                            <Input id="salon" name="salon" label="Salon / Patronage" placeholder="E.g. 7th Ukrainian Photo Awards" optional />
                            <TextArea id="issue" name="issue" label="Issue" placeholder="Desribe a problem" required />
                            <Grid gap="15px">
                                <Button element="submit">Send</Button>
                                <Flex justifyContent="center"><Button type="tertiary" to={route("app")}>Back</Button></Flex>
                            </Grid>
                        </Form>
                    </Grid>
                </Grid>
            </SupportBox>
        </SupportWrapper>
    )
}

// STYLES
const SupportWrapper = styled(Container)`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    min-height: 100vh;
    padding-top: 30px;
    padding-bottom: 30px;
`

const SupportBox = styled(Box)`
    width: 100%;

    ${tablet(css`
        width: 550px;
    `)}
`